module.exports = __webpack_public_path__ + "img/con1.c45ebe95.png";